import { useVirtualizer } from '@tanstack/react-virtual';
import React from 'react';
import { Facet, FilterOption } from 'types/Search';
import { SingleSearchFilterItem } from './SingleSearchFilterItem';
import { useBreakpoints } from 'hooks/useBreakpoints';
import { useTheme } from '@mui/material';
import SimpleBarReact from 'simplebar-react';

interface Props {
  fullList: Facet[];
  option: FilterOption;
}
export const VirtualizedFilter: React.FC<Props> = ({ fullList, option }) => {
  const parentRef = React.useRef<HTMLDivElement>(null);

  const count = fullList.length;
  const virtualizer = useVirtualizer({
    count,
    getScrollElement: () => parentRef.current,
    estimateSize: () => 40
  });
  const items = virtualizer.getVirtualItems();
  const theme = useTheme();
  const { width } = useBreakpoints();
  return (
    <SimpleBarReact
      scrollableNodeProps={{ ref: parentRef }}
      style={{
        height: 300,
        //"magic calculation
        //   // 70% sidedrawer width = 32 px padding
        width: width > theme.breakpoints.values.sm ? 236 : width * 0.7 - 32,
        overflowY: 'auto',
        contain: 'strict'
      }}
    >
      <div
        style={{
          height: virtualizer.getTotalSize(),
          width: '100%',
          position: 'relative'
        }}
      >
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            transform: `translateY(${items[0]?.start ?? 0}px)`
          }}
        >
          {items.map(virtualRow => (
            <div
              key={virtualRow.key}
              ref={virtualizer.measureElement}
              data-index={virtualRow.index}
            >
              <SingleSearchFilterItem
                filter={fullList[virtualRow.index]}
                selectedFilterOption={option.key}
              />
            </div>
          ))}
        </div>
      </div>
    </SimpleBarReact>
  );
};
